import * as React from "react";
import {
  Card as MuiCard,
  Typography,
  Box,
  Grid,
  OutlinedInput,
  Button,
  Avatar,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { ErrorMessage } from "@hookform/error-message";
import { useForm, Controller } from "react-hook-form";
import { ITeamRegForm } from "../../types/auth";
import AvatorDarkIcon from "../Icons/AvatorDarkIcon";
import CameraIcon from "../Icons/CameraIcon";
import { saveUserApi, uploadProfileAvatar } from "../../api";
import toastr from "toastr";
import { getUser, updateProfile } from "../../redux/actions/auth";
import RightArrowIcon from "../Icons/RightArrowIcon";

function EditProfile() {
  const { user } = useSelector((state: RootState) => state.auth);
  const { control, handleSubmit, errors, reset } = useForm();
  const classes = useStyles();
  const dispatch = useDispatch();
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  React.useEffect(() => {
    if (user) {
      reset({
        name: user?.name || "",
        lastName: user?.lastName || "",
        email: user?.email || "",
        //location: user?.location || ""
        phoneNumber: user?.phoneNumber || ""
      });
    }
  }, [user, reset]);
  const location = useLocation();
  const changeCommunityButton =
    location.pathname.includes("/user/editProfile") && user.type === "member";
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      let selectedFile = event.target.files[0];
      const formData = new FormData();
      formData.append("file", selectedFile);
      try {
        const userId = user["_id"];
        const resp: any = await uploadProfileAvatar(userId, formData);
        if (resp) {
          dispatch(getUser());
          toastr.success("File uploaded successfully");
        }
        console.log("File uploaded successfully:", resp);
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  const onSubmit = async (data: ITeamRegForm) => {
    try {
      data._id = user["_id"];
      const resp = await saveUserApi(data);
      const updatedUser = resp.data;
      user["name"] = data["name"];
      user["email"] = data["email"];
      user["lastName"] = data["lastName"];
      user["phoneNumber"] = data["phoneNumber"];
      dispatch(updateProfile(updatedUser));
      toastr.success("Profile Updated Successfully");
      reset({
        name:        updatedUser.name,
        lastName:    updatedUser.lastName,
        email:       updatedUser.email,
        phoneNumber: updatedUser.phoneNumber || ""
    });
    } catch (error) {
      toastr.error("Failed to update team member. Please try again.");
      console.error("Error updating team member:", error);
    }
  };
  return (
    <>
      <div className={classes.container}>
        <MuiCard className={classes.card}>
          <Box className={classes.header}>
            <Link to="/user/dashboard">
              <img src={backIcon} alt="Back" className={classes.backIcon} />
            </Link>
            <Box className={classes.logoWrapper}>
              <img src={logo} alt="Logo" className={classes.logo} />
            </Box>
          </Box>
          <Box className={classes.profileInfo}>
            <Typography variant="h5" className={classes.communityHeading}>
              Edit Profile
            </Typography>
            <div className={classes.profileContainer}>
              <div className={classes.avatarContainer}>
                {user?.avatarUrl ? (
                  <Avatar
                    alt={user?.name}
                    src={
                      process.env.REACT_APP_IMAGE_URL + "/" + user?.avatarUrl
                    }
                  />
                ) : (
                  <AvatorDarkIcon width={100} height={100} />
                )}
                <div className={classes.cameraIcon}>
                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ position: "absolute", opacity: "0" }}
                  />
                  <CameraIcon width={20} height={20} />
                </div>
              </div>
            </div>

            <Typography className={classes.textHeading}>
              {user &&
                `Welcome ${user?.name} ${
                  user?.lastName ? user.lastName : ""
                }`}{" "}
            </Typography>
            <Typography>{user && `${user?.email}`}</Typography>
          </Box>

          <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.formLabel}>
                First Name
              </Typography>
              <Controller
                className={classes.textField}
                variant="outlined"
                name="name"
                control={control}
                rules={{
                  required: "Name is required.",
                }}
                defaultValue=""
                as={
                  <OutlinedInput
                    id="name"
                    aria-describedby="name-helper-text"
                    inputProps={{
                      "aria-label": "name",
                    }}
                    labelWidth={0}
                    placeholder="First Name"
                    className={classes.inputStyle}
                  />
                }
              />
              <ErrorMessage
                as={<Typography color="error" />}
                errors={errors}
                name="name"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.formLabel}>
                Last Name
              </Typography>
              <Controller
                className={classes.textField}
                variant="outlined"
                name="lastName"
                control={control}
                rules={{
                  required: "Name is required.",
                }}
                defaultValue=""
                as={
                  <OutlinedInput
                    id="lastName"
                    aria-describedby="name-helper-text"
                    inputProps={{
                      "aria-label": "lastName",
                    }}
                    labelWidth={0}
                    placeholder="Last Name"
                    className={classes.inputStyle}
                  />
                }
              />
              <ErrorMessage
                as={<Typography color="error" />}
                errors={errors}
                name="lastName"
              />
            </Grid>
            {/* <Grid item xs={12}>
              <Typography variant="body1" className={classes.formLabel}>
                Location
              </Typography>
              <Controller
                className={classes.textField}
                variant="outlined"
                name="location"
                control={control}
                rules={{
                  required: "Name is required.",
                }}
                defaultValue=""
                as={
                  <OutlinedInput
                    id="location"
                    aria-describedby="name-helper-text"
                    inputProps={{
                      "aria-label": "location",
                    }}
                    labelWidth={0}
                    placeholder="Location"
                    className={classes.inputStyle}
                  />
                }
              />
              <ErrorMessage
                as={<Typography color="error" />}
                errors={errors}
                name="name"
              />
            </Grid> */}
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.formLabel}>
                Phone Number
              </Typography>
              <Controller
                className={classes.textField}
                variant="outlined"
                name="phoneNumber"
                control={control}
                rules={{
                  required: "Phone Number is required.",
                  pattern: {
                    // optional 1–3 digits + "+", then 3–3–4 format with dashes
                    value: /^(?:\d{1,3}\+)?\d{3}-\d{3}-\d{4}$/,
                    message:
                      "Invalid phone number format."// Use 999-999-9999 or\n1+999-999-9999 (up to 3-digit code).",
                  },
                }}
                defaultValue=""
                as={
                  <OutlinedInput
                    id="phoneNumber"
                    aria-describedby="phone-number-helper-text"
                    inputProps={{
                      "aria-label": "phoneNumber",
                    }}
                    labelWidth={0}
                    placeholder="Phone Number"
                    className={classes.inputStyle}
                  />
                }
              />
              <ErrorMessage
                as={<Typography color="error" />}
                errors={errors}
                name="phoneNumber"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.formLabel}>
                Email
              </Typography>
              <Controller
                className={classes.textField}
                variant="outlined"
                name="email"
                control={control}
                rules={{
                  required: "Email is required.",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Invalid email format.",
                  },
                }}
                defaultValue=""
                as={
                  <OutlinedInput
                    id="outlined-adornment-weight"
                    aria-describedby="outlined-weight-helper-text"
                    inputProps={{
                      "aria-label": "email",
                    }}
                    labelWidth={0}
                    placeholder="Email"
                    className={classes.inputStyle}
                  />
                }
              />
              <ErrorMessage
                as={<Typography color="error" />}
                errors={errors}
                name="email"
              />
            </Grid>
            {changeCommunityButton && (
              <>
                <Grid item xs={12}>
                  <Typography variant="body1" className={classes.formLabel}>
                    Your Community
                  </Typography>
                  <Controller
                    className={classes.textField}
                    variant="outlined"
                    name="community"
                    control={control}
                    rules={{
                      required: "Community is required.",
                      pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Invalid email format.",
                      },
                    }}
                    defaultValue=""
                    as={
                      <OutlinedInput
                        id="outlined-adornment-weight"
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          "aria-label": "email",
                        }}
                        labelWidth={0}
                        placeholder="Albertville First Nation"
                        className={classes.inputStyle}
                      />
                    }
                  />
                  <ErrorMessage
                    as={<Typography color="error" />}
                    errors={errors}
                    name="email"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: "center",
                    margin: "32px 0 8px 0",
                    width: "240px",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    style={{
                      height: "50px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    className={classes.submitBtn}
                  >
                    Change Community
                    <RightArrowIcon width={25} height={25} />
                  </Button>
                </Grid>
              </>
            )}
            <Grid
              item
              xs={12}
              style={{ textAlign: "center", margin: "32px 0 8px 0" }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                style={{ height: "50px" }}
                className={classes.submitBtn}
              >
                Save changes
              </Button>
            </Grid>
          </form>
        </MuiCard>
      </div>
    </>
  );
}

export default EditProfile;
